export const iosVersion = '2.0.0.0';
